import { Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { PointOfServicesRequestConfig, PointOfServicesStatusRequest } from './custom-store-finder.model';
import { OccEndpointsService, TranslationService } from '@spartacus/core';
import { HttpClient } from '@angular/common/http';
import { failStatus, successStatus } from '../../../../../core/models/request-status.model';

@Injectable({
  providedIn: 'root',
})
export class CustomStoreFinderAdapter {
  constructor(
    private http: HttpClient,
    private translationService: TranslationService,
    private occEndPointService: OccEndpointsService,
  ) {}

  getPointOfServices(config: PointOfServicesRequestConfig): Observable<PointOfServicesStatusRequest> {
    const queryParams = {
      query: config.search,
      country: config.countryISOCode,
      latitude: config.latitude,
      longitude: config.longitude,
      types: config.types,
      products: config.product,
      uom: config.unit,
      radius: config.distance,
      fields: 'FULL',
    };

    // const queryParams = {
    //   query: '80420120',
    //   country: 'BR',
    //   latitude: '-25.438818690015832',
    //   longitude: '-49.27871064800389',
    //   types: 'WAREHOUSE,DISTRIBUTOR',
    //   products: 'ELECTRIC_MOTOR,GENERATOR',
    //   uom: 'MILES',
    //   radius: '2',
    //   fields: 'FULL',
    // };

    const url = this.occEndPointService.buildUrl('getPointOfServices', { queryParams });

    return this.http.get(url).pipe(
      map((response: any) => {
        return {
          ...this.normalizePOS(response),
          ...successStatus,
        };
      }),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            message: textError,
            ...failStatus,
            // ...successStatus,
            // pointOfServices: pointOfServicesMock,
          })),
        );
      }),
    );
  }

  normalizePOS(response: any): PointOfServicesStatusRequest {
    // this logic was implemented to handle the case when the response does not return any store
    // it will return the current location as a store to set the map center
    // to ensure that we have how to know if there is or no store we create a flag noPOS

    return {
      pointOfServices: response.stores.length
        ? response.stores
        : [
            {
              geoPoint: {
                latitude: response.sourceLatitude,
                longitude: response.sourceLongitude,
              },
            },
          ],
      infoMessage: response.infoMessage,
      noPOS: (response?.stores || [])?.length === 0,
    };
  }
}
